import { faUserFriends } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UIView } from '@uirouter/react';
import { Button, Space } from 'antd';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Table } from '@/components/table';
import { PERMISSION_OBJ_FARMER, PERMISSION_READ } from '@/constants/permissions';
import { withPermissions } from '@/hocs/permission';
import { farmStore } from '@/stores';
import { getGenericFilters, toQueryFormat } from '@/components/table/utils';

import { columns } from './setup';

const store = farmStore;

const GoToFarmersButton = withPermissions([[PERMISSION_OBJ_FARMER, PERMISSION_READ]])(
  ({ onClick }: { onClick: () => void }) => (
    <Button onClick={onClick} icon={<FontAwesomeIcon icon={faUserFriends} />}>
      {'\u00A0\u00A0'}
      <FormattedMessage id="menu.farmers" />
    </Button>
  ),
);

export const FarmsList = observer(({ transition }: any) => {
  const items = store.items;

  useEffect(() => {
    store.forceLoad({ sort: 'id:-1' });
  }, []);

  const genericFilters = useMemo(() => getGenericFilters(columns), []);

  const onChangeTable = (...args) => {
    const params = toQueryFormat.apply(null, [genericFilters, ...args]);
    store.forceLoad(params);
  };

  const onRow = (record: cyrian.api.farms.Farm) => ({
    onClick: () => transition.router.stateService.go('base-layout.farms.view', { farmId: record.id }),
    className: 'table-row-cursor',
  });

  const onGoToFarmers = () => transition.router.stateService.go('base-layout.farmers');

  return (
    <>
      <Space>
        <GoToFarmersButton onClick={onGoToFarmers} />
      </Space>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={[...items]}
        store={store}
        scroll={{ x: 1000 }}
        onRow={onRow}
        onChange={onChangeTable}
      />
      <UIView />
    </>
  );
});
